<ng-template #itemTemplate let-item>
    <span [ngClass]="{ 'text-red-500': isBlocked(item) }">{{ generateNameLabel(item) }}</span>
    <div class="text-sm text-gray-600">{{ generatePostalAddressLabel(item) }}</div>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    <span [ngClass]="{ 'text-red-500': isBlocked(item) }">{{ generateNameLabel(item) }}</span>
</ng-template>

<ng-template #postSelectTemplate let-item>
    <i
        *ngIf="formControl?.value"
        class="grow-0 fa fa-info clickable flex items-center justify-center p-2 text-primary"
        (click)="showAddressSidebar()"
        pTooltip="{{ 'crm.show-address' | translate }}"
    ></i>
</ng-template>

<p-drawer
    [(visible)]="sidebarVisible"
    [appendTo]="'body'"
    position="right"
    styleClass="sidebar-style"
>
    @if (sidebarVisible) {
        <app-address-header-card-widget [address]="getAddress()"></app-address-header-card-widget>
        <!-- below we can show some more info-->
    }
</p-drawer>
